import { EquipamientoFiltro } from "../../../types/Equipamiento";

/**
 * Parámetros de GET /equipamiento/findBy. Un nombre vacío o un estado TODOS ('') no se envían,
 * porque el backend los interpreta como "sin filtro".
 */
export const armarParametrosBusqueda = (filtro: EquipamientoFiltro, page: number, size: number): Record<string, string | number> => {
    const params: Record<string, string | number> = { page, size };
    const nombre = filtro.nombre.trim();
    if (nombre !== '') {
        params.nombre = nombre;
    }
    if (filtro.activo === 'true' || filtro.activo === 'false') {
        params.activo = filtro.activo;
    }
    return params;
}
